import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=93e8d78e"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports